import { render, staticRenderFns } from "./PhoneDisplay.vue?vue&type=template&id=0b946cd2"
import script from "./PhoneDisplay.vue?vue&type=script&lang=js"
export * from "./PhoneDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports